"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDataGridHeader_unstable", {
    enumerable: true,
    get: function() {
        return renderDataGridHeader_unstable;
    }
});
const _renderTableHeader = require("../TableHeader/renderTableHeader");
const renderDataGridHeader_unstable = (state)=>{
    return (0, _renderTableHeader.renderTableHeader_unstable)(state);
};
